import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ConfigContext } from "../../App";

export default function PNSHeader(props: any) {
    const historyAPI = useHistory();
    const locales = useContext(ConfigContext).appConfig.languageData;

    useEffect(() => {
        const style = document.createElement('style');
        style.textContent = `
            .pns-stripe {
                scroll-padding-top: 80px;
            }
            
            .checkbox-container:focus-within {
                scroll-margin-top: 80px;
                scroll-margin-bottom: 80px;
            }
            
            .product-label:focus-within {
                scroll-margin-top: 80px;
                scroll-margin-bottom: 80px;
            }
            
            *:focus {
                scroll-margin-top: 80px;
                scroll-margin-bottom: 80px;
            }
        `;
        document.head.appendChild(style);
        
        return () => {
            document.head.removeChild(style);
        };
    }, []);

    return (
        <div className="status-stripe pns-stripe">
            <div className="container">
                <div className="text">{props.noText ? '' : props.helpText?'User Guide':locales.subscriptions_preferences}</div>
                <button 
                    className="go-to-overview pull-right"
                    onClick={() => {
                        if (props.manageSubscription) {
                            historyAPI.push("/proactive-notifications/manage")

                        } else {
                            historyAPI.push("/")
                        }
                    }}
                    aria-label={props.manageSubscription ? locales.manage_subscriptions : locales.home_redirect}
                >
                    <span><span className={props.manageSubscription ? "manage-text" : "home-text"}><i className="icon-home"></i><span>{props.manageSubscription ? locales.manage_subscriptions : locales.home_redirect}</span></span></span>
                </button>
            </div>
        </div>
    )
}
